import React from 'react';
import PropTypes from 'prop-types';

import {Box, Button, Typography} from 'views/components';

import CalenderTodayIcon from '@mui/icons-material/CalendarToday';
import moment from 'moment';

const WeeklyCalendarTimeChanger = (props) => {
  const {onWeekChange} = props;

  const [currentDate, setCurrentDate] = React.useState(moment());
  const [weekDays, setWeekDays] = React.useState(getWeekDays());

  React.useEffect(() => {
    onWeekChange(weekDays);
  }, []);

  const goToPreviousWeek = () => {
    const newDate = currentDate.clone().subtract(1, 'week');
    setCurrentDate(newDate);
    const newWeekDays = getWeekDays(newDate);
    setWeekDays(newWeekDays);
    onWeekChange(newWeekDays);
  };

  const goToNextWeek = () => {
    const newDate = currentDate.clone().add(1, 'week');
    setCurrentDate(newDate);
    const newWeekDays = getWeekDays(newDate);
    setWeekDays(newWeekDays);
    onWeekChange(newWeekDays);
  };

  const getCalenderTodayText = () => {
    const startOfWeek = weekDays[0];
    const endOfWeek = weekDays[6];
    return `${startOfWeek.format('MMM D')} - ${endOfWeek.format('MMM D, YYYY')}`;
  };

  return (
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
      padding: '8px 16px',
    }}>
      <Box
        sx={{
          display: 'flex',
        }}>
        <Button
          onClick={goToPreviousWeek}
          sx={{
            'minWidth': '36px',
            'padding': '4px 8px',
            'border': '1px solid #e0e0e0',
            'backgroundColor': 'white',
            'color': 'black',
            'boxShadow': 'none',
            '&:hover': {
              backgroundColor: '#f5f5f5',
            },
          }}
        >
          &lt;
        </Button>

        <Box sx={{display: 'flex', alignItems: 'center', mx: 2}}>
          <CalenderTodayIcon sx={{mr: 1}} />
          <Typography
            variant="h6"
            sx={{
              fontWeight: 'medium',
            }}>
            {getCalenderTodayText()}
          </Typography>
        </Box>
        <Button
          onClick={goToNextWeek}
          sx={{
            'minWidth': '36px',
            'padding': '4px 8px',
            'border': '1px solid #e0e0e0',
            'backgroundColor': 'white',
            'color': 'black',
            'boxShadow': 'none',
            '&:hover': {
              backgroundColor: '#f5f5f5',
            },
          }}
        >
          &gt;
        </Button>
      </Box>
    </Box>
  );
};
const getWeekDays = (referenceDate = null) => {
  const days = [];
  const reference = referenceDate ? moment(referenceDate) : moment();
  const start = reference.clone().startOf('week');
  for (let i = 0; i < 7; i++) {
    days.push(start.clone().add(i, 'days'));
  }
  return days;
};


WeeklyCalendarTimeChanger.propTypes = {
  onWeekChange: PropTypes.func.isRequired,
};

export default WeeklyCalendarTimeChanger;
